export const RESULT_TYPES = {
  DIRECT: 'direct',
  AVERAGE: 'average',
  LINEAR: 'linear',
  MATRIX: 'matrix',
  WORD_CLOUD: 'word-cloud',
}

export const CELL_MERGE_SETTINGS = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 2 } }]

export const MATRIX_CELL_MERGE_SETTINGS = [
  { s: { r: 0, c: 0 }, e: { r: 0, c: 2 } },
  { s: { r: 1, c: 0 }, e: { r: 1, c: 2 } },
]
